import { z } from 'zod';
import {
	PLAIN_TEXT_WITH_EMOJI_ERROR_MESSAGE,
	PLAIN_TEXT_WITH_EMOJI_REGEX,
} from '../../constants/validation.constants';
import { requiredString, requiredUuid } from '../base.schema';
import { DeviceTypeSchema } from './authRequests.schema';

export const authSchemaRef = 'auth';

export const authSchema = z
	.object({
		deviceId: requiredUuid('schemaAttributes.deviceId').meta({
			description: 'Unique identifier for the device',
			example: '123e4567-e89b-12d3-a456-426614174000',
		}),
		deviceName: requiredString('schemaAttributes.deviceName')
			.regex(
				PLAIN_TEXT_WITH_EMOJI_REGEX,
				PLAIN_TEXT_WITH_EMOJI_ERROR_MESSAGE
			)
			.meta({
				description:
					'Friendly name for the device, can contain text and emojis.',
				example: 'iPhone',
			}),
		deviceType: DeviceTypeSchema,
		createdAt: z
			.union([z.string().datetime('Invalid date format'), z.date()])
			.meta({
				description: 'Date and time when the category was created.',
				example: '2023-10-01T12:00:00Z',
			}),
	})
	.meta({
		description: 'Schema for authentication',
		ref: authSchemaRef,
	})
	.strict();

export type AuthSchemaType = z.infer<typeof authSchema>;
